import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";
import { convertEpochToDate } from "@egovernments/digit-ui-module-pt/src/utils";
import { formatLabel } from "./helper/revenueFormHelper";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import DialogContentModal from "../../../../../../templates/ApplicationDetails/components/DialogContent";
import PerRevenueDetail from "./PerRevenueDetail";

const useStyles = makeStyles({
  table: {
    minWidth: 850,
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff",
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd",
  },
  blueText: {
    color: "#1F4A7C",
  },
});

const headerData = [{ slno: "Sr. No" }, { feeType: "Budget Head" }, { totalAmount: "Total Amount" }];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  ":hover": {
    backgroundColor: "#1f4a7c4d",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const InboxTable = ({ apiData, tenantId, location }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React.useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedFeeType, setSelectedFeeType] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper sx={{ overflow: "hidden", marginY: 2 }}>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableRow}>
              {headerData.map((item) => (
                <TableCell key={Object.values(item)[0]}>{Object.values(item)[0]}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: "#fbfaff" }}>
            {apiData &&
              apiData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                <StyledTableRow
                  key={row.serialNo}
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowModal(true);
                    setSelectedFeeType(row?.feeType);
                  }}
                >
                  <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                  <StyledTableCell>{formatLabel(row?.feeType) || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row?.totalAmount || row?.amount || "0"}</StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 75, 100]}
        component="div"
        count={apiData?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {showModal && (
        <DialogContentModal title={"Revenue Details"} dataOpen={showModal} onClose={() => setShowModal(false)}>
          <PerRevenueDetail tenantId={tenantId} selectedFeeType={selectedFeeType} location={location}></PerRevenueDetail>
        </DialogContentModal>
      )}
    </Paper>
  );
};

export default InboxTable;
